/* eslint-disable camelcase */
import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
    objects: {},
}

export const getters = {}

export const mutations = {
  SET_PICKUPREQUESTS(state, objects) {
      let updatedObjects = {}
      for (let key in objects) {
          if (!objects[key].deleted_at) {
              // Remove the '__typename' field that gets added by GraphQL
              delete objects[key].__typename
              // Stage the update so we can just do one Vue.set
              updatedObjects[objects[key].id] = objects[key]
          } else if (state.pickuprequest.hasOwnProperty(objects[key].id)) {
              // Immediately delete the object
              Vue.delete(state.pickuprequest, objects[key].id)
          }
      }
      state.pickuprequest = {
          ...updatedObjects,
      }
  },
    SET_CLIENTPICKUPREQUESTS(state, objects) {
        let updatedObjects = {}
        for (let key in objects) {
            if (!objects[key].deleted_at) {
                // Remove the '__typename' field that gets added by GraphQL
                delete objects[key].__typename
                // Stage the update so we can just do one Vue.set
                updatedObjects[objects[key].id] = objects[key]
            } else if (state.clientobjects.hasOwnProperty(objects[key].id)) {
                // Immediately delete the object
                Vue.delete(state.clientobjects, objects[key].id)
            }
        }
        state.clientobjects = {
            ...updatedObjects,
        }
    },
    SET_CLIENTPICKUPREQUEST(state, objects) {
        state.clientpickuprequest = objects
    },
}

export const actions = {
    init({ commit, rootState }) {
        // Initialise the GraphQL client
        graphqlClient = createGraphQLClient(rootState)
    },
    async getPickupRequests({commit}){
      try {
          return await
              graphqlClient.query({
                  query: gql`
                  query{
                    pickuprequests {
                      id
                      service {
                        id
                        service_title
                        waste_type {
                          name
                        }
                        site{
                          address
                          suburb
                          state
                          country
                          postcode
                        }
                      }

                      client {
                        id
                        client_name
                      }
                      pickup_date
                      pickup_date_raw
                      pickup_timewindow
                      notes
                      created_at
                      transaction_id
                      status
                    }
                  }
                `,
              }).then((response) => {
                commit('SET_PICKUPREQUESTS', response.data.pickuprequests)
              })
      } catch (ex) {
          console.error(ex)
          throw ex
      }
    },


    async getClientPickupRequests({ commit }) {
        try {
            const gql = require( 'graphql-tag');
            let token = JSON.stringify(this.getters['auth/getCurrentUser'].token);
            return await
                graphqlClient.query({
                    query: gql`
                    query{
                      clientPickupRequests(token:${token}) {
                        id
                        service {
                          id
                          service_title
                          waste_type {
                          	name
                          }
                        }
                        client {
                          id
                        }
                        pickup_date
                        pickup_timewindow
                        notes
                        created_at
                        transaction_id
                        status
                      }
                    }
                  `,
                }).then((response) => {
                  commit('SET_CLIENTPICKUPREQUESTS', response.data.clientPickupRequests)
                })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async createPickupRequest({ commit, dispatch }, {serviceId, clientId, pickupDate, pickupTimeWindow, notes} = {}) {
        try {
            const response = await graphqlClient.mutate({
                mutation: gql`
                mutation CreatePickupRequest($Service: ID $PickupDate: String, $PickupTimeWindow:String, $Client:ID, $Notes:String )  {
                  createPickupRequest(pickup:{service_id: $Service pickup_date:$PickupDate pickup_timewindow:$PickupTimeWindow client_id:$Client notes:$Notes }) {
                    id
                  }
                }
                `,
                variables: {Service: serviceId, Client: clientId, PickupDate: pickupDate,PickupTimeWindow:pickupTimeWindow, Notes:notes},
            })
            return response;
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async createCollectionFromPickupRequest({ commit, dispatch }, { pickup_id, service_id, created_by, collection_date, completed, processed} = {}) {
        try {
          // console.log(pickup_id)
          // console.log(service_id)
          // console.log(created_by)
          // console.log(collection_date)
          // console.log(runsheetId)
            const response = await graphqlClient.mutate({
                mutation: gql`
                  mutation CreateCollectionFromPickupRequest($Pickup_id:ID $Service_id: Int $Created_by: Int $Collection_date: String $Completed: Boolean $Processed: Boolean)  {
                    createCollectionFromPickupRequest(pickup_id:$Pickup_id collection:{service_id: $Service_id created_by:$Created_by collection_date:$Collection_date completed:$Completed processed:$Processed }) {
                      id
                    }
                  }
                  `,
                variables: {  Pickup_id: pickup_id, Service_id: service_id,  Created_by: created_by, Collection_date: collection_date, Completed: completed, Processed: processed},
            })
            return response;
            // dispatch('getCollectionsByServiceId')
        } catch (ex) {

            console.error(ex)

            throw ex
        }
    },

    async updatePickupRequestStatus({ commit, dispatch }, {id,status } = {}) {
        try {
            const response = await graphqlClient.mutate({
                mutation: gql`
                mutation UpdatePickupRequest($Id: ID ,$Status:String )  {
                  updatePickupRequest(id:$Id pickup:{status:$Status }) {
                    id
                  }
                }
                `,
                variables: {Id: id, Status:status},
            })
            return response;
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },



}
